import {TIKTOK_PLAYER_LINK_PREFIX} from './constants'

/**
 * Extracts the video ID from a TikTok URL
 * @param url - The TikTok URL to extract the video ID from
 * @returns The video ID if found, null otherwise
 */
async function extractTikTokVideoId(url: string) {
  try {
    // Handle vm.tiktok.com and vt.tiktok.com URLs
    if (url.includes('vm.tiktok.com') || url.includes('vt.tiktok.com')) {
      try {
        const response = await fetch(url, { method: 'HEAD', redirect: 'follow' });
        url = response.url;
      } catch (error) {
        console.error('Error following TikTok redirect:', error);
        return null;
      }
    }

    // Handle www.tiktok.com URLs
    if (url.includes('tiktok.com')) {
      const match = url.match(/\/video\/(\d+)/);
      return match ? match[1] : null;
    }

    return null;
  } catch (error) {
    console.error('Error extracting TikTok video ID:', error);
    return null;
  }
} 

export const convertTiktokLink = async (link: string) => {
  if (link.startsWith(TIKTOK_PLAYER_LINK_PREFIX)) {
    return link
  }

  const videoId = await extractTikTokVideoId(link)
  if (videoId) {
    return TIKTOK_PLAYER_LINK_PREFIX + videoId
  } else {
    return null
  }

}